module.exports = "/_next/static/images/9d839de89d81db461a8046c11618ddf7-app-screenshots-xs@3x.jpg";